import { Frame } from 'features/Frames/types';

type DetailConfig = {
  prefix: string;
  detailKey: keyof Omit<Frame, 'status'>;
  nextDetailKey?: keyof Omit<Frame, 'status'>;
};

const detailsConfig: DetailConfig[] = [
  { prefix: 'Publisher', detailKey: 'publisher', nextDetailKey: 'environment' },
  { prefix: 'Environment', detailKey: 'environment', nextDetailKey: 'formatSize' },
  { prefix: 'Format Size', detailKey: 'formatSize', nextDetailKey: 'resolution' },
  { prefix: 'Resolution', detailKey: 'resolution' },
  { prefix: 'Frame ID', detailKey: 'id', nextDetailKey: 'displayUnitId' },
  { prefix: 'Display Unit ID', detailKey: 'displayUnitId', nextDetailKey: 'broadsignFrameId' },
  { prefix: 'Broadsign Frame ID', detailKey: 'broadsignFrameId', nextDetailKey: 'leader' },
  { prefix: 'Leader Frame ID', detailKey: 'leader' },
];

export const createFrameDetailsRows = (currentFrame: Omit<Frame, 'status'>) => {
  const createRowItem = ({ prefix, detailKey, nextDetailKey }: DetailConfig) => ({
    prefix,
    detail: currentFrame[detailKey],
    nextDetail: nextDetailKey ? currentFrame[nextDetailKey] : null,
  });

  const splitIndex = 4;
  const frameDetailsFirstRow = detailsConfig.slice(0, splitIndex).map(createRowItem);
  const frameDetailsSecondRow = detailsConfig.slice(splitIndex).map(createRowItem);

  return { frameDetailsFirstRow, frameDetailsSecondRow };
};
